import { IconButton, IconButtonProps, Tooltip } from '@mui/material'

interface SquareIconButtonProps extends IconButtonProps {
  tooltip?: string
}

const SquareIconButton: React.FC<SquareIconButtonProps> = ({ sx, tooltip, ...props }) => {
  const button = (
    <IconButton
      {...props}
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        borderRadius: 1,
        padding: 1.25,
        '&:hover': {
          bgcolor: 'primary.dark'
        },
        ...sx,
      }}
    />
  )

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>
  }

  return button
}

export default SquareIconButton
